<template>
    <div>
        <div class="form-group">
            <label v-show="passwordLabel && passwordLabel.length" :for="id">{{ passwordLabel }}</label>

            <password
                v-model="password"
                defaultClass="form-control password-meter"
                :name="id"
                :placeholder="validatePassword ? placeholder : ''"
                :id="id"
                :toggle="showPasswordReveal"
                :secureLength="minimalCharCount"
                :badge="validatePassword"
                :showStrengthMeter="validatePassword"
                :required="required"
                @blur="checkConfirmation(true)"/>

            <div class="invalid-feedback"
                 v-if="this.error_messages.length"
                 style="display:block;">
                <ul>
                    <li v-for="error in this.error_messages">{{ error }}</li>
                </ul>
            </div>

            <div v-if="this.restrictions">
                <ul class="text-muted small pl-3">
                    <li v-for="restriction in this.restrictions"> {{ restriction }}</li>
                </ul>
            </div>

        </div>

        <div class="form-group" v-if="showPasswordConfirmation">
            <label :for="id + '_confirmation'">{{ __('auth.confirm_password') }}</label>

            <password
                v-model="password_confirmation"
                defaultClass="form-control password-meter"
                :name="this.id+'_confirmation'"
                :placeholder="this.__('auth.repeat_password')"
                :id="this.id+'_confirmation'"
                :toggle="showPasswordReveal"
                :badge="false"
                :showStrengthMeter="false"
                @blur="checkConfirmation(true)"/>

            <div class="invalid-feedback"
                 v-if="showPasswordConfirmation && this.password_unequal_message.length"
                 style="display:block;">
                <ul>
                    <li>{{ password_unequal_message }}</li>
                </ul>
            </div>

        </div>

    </div>
</template>


<script>
import Password from 'vue-password-strength-meter'
import passwordValidation from '../mixins/passwordValidation'
import trans from '../mixins/trans'
import axios from 'axios'
import eventBus from "../mixins/eventBus"

export default {

    mixins: [
        passwordValidation,
        trans
    ],

    components: {
        Password
    },

    props: {
        'id': String,
        'placeholder': String,
        'required': {
            type: Boolean,
            default: true
        },
        'validatePassword': {
            type: Boolean,
            default: true
        },
        'minimalCharCount': Number,
        'suggestion': '',
        'suggestionUrlJs': '',
        'showPasswordReveal': {
            type: Boolean,
            default: true
        },
        'showPasswordConfirmation': {
            type: Boolean,
            default: true
        },
        'restrictions': Array,
        'passwordLabel': String,
        'passwordPolicyRegexp': {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            password: null,
            pwSuggestion: this.suggestion,
            error_messages: [],
            is_valid: false,
            password_confirmation: '',
            password_unequal_message: '',
            password_validated: false,
            password_confirmed: false,
        };
    },

    watch: {
        password(value) {
            if (this.validatePassword) {
                let self = this;
                self.checkPassword(self, value);
            }
        },

        password_confirmation() {
            let self = this;
            self.checkConfirmation(false);
        },

        isValid(value) {
            if (value) {
                eventBus.$emit('password-validated');
            } else {
                eventBus.$emit('password-invalidated');
            }
        }
    },

    mounted: function () {
        let self = this;
        $('#' + this.id)[0].suggest = function () {
            self.suggest();
        };
    },

    computed: {
        isValid() {
            return this.password_validated && this.password_confirmed;
        }
    },

    methods: {
        getSuggestionUrl() {
            let f = eval(this.suggestionUrlJs);
            return typeof (f) === 'function' ? f() : '';
        },

        suggest() {
            let self = this;
            let url = this.getSuggestionUrl();
            if (url) {
                axios.get(url).then(response => {
                    if (response.data.success) {
                        self.password = response.data.suggestion;
                        self.checkPassword(self, self.password);
                    }
                });
            } else if (this.pwSuggestion !== '') {
                this.password = this.pwSuggestion
                self.checkPassword(self, this.password);
            }
        },

        checkPassword(self, value) {
            self.error_messages = self.checkPasswordValidity(value, self.passwordPolicyRegexp);
            if (self.error_messages.length) {
                $('#' + self.id).addClass('is-invalid');
                self.password_validated = false;
            } else {

                $('#' + self.id).removeClass('is-invalid');
                self.password_validated = true;
            }
        },

        checkConfirmation(ignore_empty) {
            if (!this.showPasswordConfirmation) {
                return;
            }

            if (ignore_empty && this.password_confirmation === "") {
                return;
            }

            if (this.password_confirmation === this.password) {
                this.password_unequal_message = '';
                $('#' + this.id + '_confirmation').removeClass('is-invalid');
                this.password_confirmed = true;
            } else {
                this.password_unequal_message = this.__('auth.password_unequal');
                $('#' + this.id + '_confirmation').addClass('is-invalid');
                this.password_confirmed = false;
            }
        }
    },

}
</script>


<style scoped>
    .Password {
        max-width: none;
    }

    .Password >>> .Password__badge, .Password >>> .Password__toggle {
        margin-right: 1rem;
    }

    .Password >>> .Password__badge {
        border-radius: .3rem;
        padding: .2rem;
        width: 2rem;
        height: 1.4rem;
        font-size: 1rem;
        text-align: center;
    }
</style>
